/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { BN, Program } from '@coral-xyz/anchor';
import { LAMPORTS_PER_SOL, PublicKey, SystemProgram } from '@solana/web3.js';
import { generateWithDrawSigners } from './generateWithDrawSigners';
import { BlackjackContract } from './types/blackjack_contract';
import { SignerMessage, WithdrawSigners } from '../types.ds';
const ADMIN_PUB_KEY = process.env.REACT_APP_ADMIN_PUB_KEY;
export const withdrawBalance = async (
  amount: number,
  program: Program<BlackjackContract>,
  receiverPubKey: PublicKey,
  nounceKeys: WithdrawSigners
) => {
  const withdrawAmount = amount / 1003;
  const withdrawAmountInLamports = withdrawAmount * LAMPORTS_PER_SOL;

  if (!ADMIN_PUB_KEY) {
    return;
  }
  const adminAccountPDA = new PublicKey(ADMIN_PUB_KEY);

  if (!nounceKeys) {
    throw new Error('Nounce keys not found!');
  }
  const adminNonce = nounceKeys.signers.nounceKey;
  const nounceStamp = new BN(nounceKeys.signers.nounceStamp);
  try {
    const tx = await program.methods
      .withdrawSol(new BN(withdrawAmountInLamports), adminNonce, nounceStamp)
      .accounts({
        // @ts-ignore
        adminAccount: adminAccountPDA,
        user: receiverPubKey,
        systemProgram: SystemProgram.programId,
        signers: [],
      })
      .rpc();
    if (tx) {
      return tx;
    } else {
      return null;
    }
  } catch (error) {
    throw new Error('Failed to withdraw balance.');
  }
};
